import Cookies from "js-cookie";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { setActiveMemberVariables } from "../../actions/taskSidebar";
import { AUTH_TOKENS, number, route } from "../../config";
import config from "../../env.config";
import { getActiveMemberVariables } from "../../shared/services/workflow.services";
import Loader from "../Loader/Loader";
import { getDefaultTaskValues, getRecentAssignee } from "../Tasks/tasks.service";
import TaskSidebarContent from "./TaskSidebarContent/TaskSidebarContent";
import TransferOwnershipPopup from "./TaskSidebarContent/TransferOwnershipPopup";
import TaskSidebarFooter from "./TaskSidebarFooter/TaskSidebarFooter";
import TaskSidebarHeader from "./TaskSidebarHeader/TaskSidebarHeader";
import TaskSidebarShimmer from "./TaskSidebarShimmer";
import TaskSidebarSidepanel from "./TaskSidebarSidepanel/TaskSidebarSidepanel";
import { getUpdatedData, updateSections } from "./sidebar.helper";

/**
 * TaskSidebar main component
 * @props {}
 */
const TaskSidebar = () => {
  const [isTaskNameEmpty, setIsTaskNameEmpty] = useState(false);
  const dispatch = useDispatch();
  const { isNewTask, task, showLoader, newTaskData, isSidebarLoading, showTransferOwnershipPopup } = useSelector((state) => state.taskSidebar);
  const { defaultDetails } = useSelector((state) => state.tasks);
  const assigneeList = useSelector((state) => state.tasks.defaultDetails.assigneeList);
  const { user } = useSelector((state) => state.auth);
  const { allComments: comments, allReplies: replies } = useSelector((state) => state.comments);
  const { projectId } = useParams();
  const [activeUserList, setActiveUserList] = useState([]);
  const [isSidebarLoader, setIsSidebarLoader] = useState(false);
  const taskSidebarPath = window.location.pathname === route.PRIVATE_ROUTE.TASK_SIDEBAR.PATH;
  const [updated, setUpdated] = useState({
    isDetailsUpdated: 0,
    isTaskMoved: 0,
    isFlowUpdated: 0,
    isCommentModified: 0,
    isReplyModified: 0,
  });
  const anchor = useRef(null);
  const flowElementsSectionRef = useRef(null);
  const [provider, setProvider] = useState(null);
  useEffect(() => {
    dispatch(getRecentAssignee({ userId: user?.id }));
  }, [user?.id]);


  useEffect(() => {
    if (!defaultDetails?.isAdded && !taskSidebarPath) {
      dispatch(getDefaultTaskValues(user.companyId, user.id, projectId));
    }
  }, [task?.taskId]);

  useEffect(() => {
    setIsSidebarLoader(isSidebarLoading);
  }, [isSidebarLoading]);

  /** sse event stream call */
  useEffect(() => {
    let source;
    if (task?.taskId) {
      source = new EventSource(
        `${config.BASE_URL.BASE_API_URL}/stream/getActiveUsers?taskId=${task.taskId}&authorization=${Cookies.get(AUTH_TOKENS.JWT_TOKEN)}&userId=${
          user.id
        }`
      );
      source.onmessage = (e) => {
        const list = assigneeList?.filter((a) => {
          return JSON.parse(e.data)?.find((user) => +user.UserId === +a?.value);
        });
        setActiveUserList(list);
        const updatedFlags = JSON.parse(e.data)?.find((data) => +data.UserId === +user.id);
        updateSections(setUpdated, updatedFlags);
      };
    }

    return () => {
      if (task.taskId) {
        source?.close();
      }
    };
  }, [task?.taskId]);

  /** Trigger's api call based on updated flag*/
  useEffect(() => {
    (async () => {
      await getUpdatedData({ task, user, comments, replies, updated });
    })();
  }, [updated]);

  // This function will run after the component has been completely rendered
  // useEffect(() => {
  //   const elmnt = document.getElementById(scrollSection);
  //   if (elmnt) {
  //     elmnt.scrollIntoView();
  //   }
  // });

  useEffect(() => {
    (async () => {
      const activeMemberVariables = await getActiveMemberVariables({ companyId: user.companyId });
      dispatch(setActiveMemberVariables(activeMemberVariables));
    })();
  }, [user.companyId]);

  return (
    <>
      {isSidebarLoader ? (
        <TaskSidebarShimmer />
      ) : (
        <div className='tasksidebar-container position-relative d-flex h-100 w-100' id='task-sidebar'>
          <div className='sidepanel-container border-left border-right'>
            <TaskSidebarSidepanel />
          </div>
          <div className='sidebar-right-container flex-grow-1 d-flex flex-column' ref={anchor}>
            <div className='sidebar-header'>
              <TaskSidebarHeader
                isTaskNameEmpty={isTaskNameEmpty}
                setIsTaskNameEmpty={setIsTaskNameEmpty}
                activeUserList={activeUserList}
                flowElementsSectionRef={flowElementsSectionRef}
              />
            </div>
            <div className='sidebar-content overflow-y-auto'>
              {(Object.keys(task)?.length > number.ZERO || isNewTask) && (
                <TaskSidebarContent provider={provider} setProvider={setProvider} flowElementsSectionRef={flowElementsSectionRef} />
              )}
            </div>
            {isNewTask && <TaskSidebarFooter setIsTaskNameEmpty={setIsTaskNameEmpty} provider={provider} setProvider={setProvider} />}
            {showTransferOwnershipPopup && <TransferOwnershipPopup anchor={anchor} />}
          </div>
          <div className='task-sidebar-loader'>{showLoader && <Loader />}</div>
        </div>
      )}
    </>
  );
};

export default TaskSidebar;
